import axios, { CancelTokenSource } from 'axios';
import { getWhenAuthorized, deleteWhenAuthorized, patchWhenAuthorized } from './api';

export interface IProfileFormState {
    givenName: string;
    familyName: string;
    title: string;
    phone: string;
    mobile: string;
    email: string;
    description: string;
    alternateEmails: string[];
    companyName: string;
    companyId: number | undefined;
    dropzoneImageDataUri: string;
    uploadedImageUri: string;
    linkedInUrl: string;
    descriptionGroups: string[]
}

export const getCurrentUser = async (cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => '/api/person', cancelTokenSource);

export const getProfile = async (personId: number, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        return await getWhenAuthorized(() => `/api/person/${personId}`, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }

    return undefined;
}

export const getProfileByInitials = async (initials: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        return await getWhenAuthorized(() => `/api/person/initials/${initials}`, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }

    return undefined;
}

export const updateProfile = async (personId: number, updateProfileRequest: IProfileFormState, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        return await patchWhenAuthorized(() => `/api/person/${personId}`, updateProfileRequest, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }

    return undefined;
}

export const getLinkedInData = async (personId: number, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        return await getWhenAuthorized(() => `/api/person/${personId}/linkedin`, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }

    return undefined;
}

export const disconnectLinkedIn = async (cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        return await deleteWhenAuthorized((personId) => `/api/person/${personId}/linkedin`, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }

    return undefined;
}

export const logNetworkVisit = async (personId: number, groupId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        return await patchWhenAuthorized(() => `/api/person/${personId}/networkvisit/${groupId}`, { }, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }

    return undefined;
}

export const getGroups = async (cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(id => `/api/person/${id}/groups`, cancelTokenSource);

export const getGroupsById = async (personId: number, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(id => `/api/person/${personId}/groups`, cancelTokenSource);